module.exports = __webpack_public_path__ + "system/img/abbreviationBig.8b2693c4.png";